// Días al inicio del mes en los que todavía se puede cancelar una factura
// global del mes anterior.
export const GLOBAL_CANCEL_MAX_DAY = 3;

const isSameMonth = (a, b) =>
  a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();

// Una factura se cancela dentro de su mismo mes. Las globales también se
// pueden cancelar los primeros días del mes siguiente.
export const canCancelInvoice = (date, isGlobal, today = new Date()) => {
  const invoiceDate = new Date(date);
  if (isSameMonth(invoiceDate, today)) return true;

  const previousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  return (
    Boolean(isGlobal) &&
    isSameMonth(invoiceDate, previousMonth) &&
    today.getDate() <= GLOBAL_CANCEL_MAX_DAY
  );
};
